import { useState, useEffect, useCallback } from 'react'
import { DateUtils } from '@ocean/utils'

const useCountdown = () => {
  const [countdown, setCountdown] = useState<number>()
  const [formattedCountdown, setFormattedCountdown] = useState<string>()

  useEffect(() => {
    countdown &&
      countdown > 1 &&
      setTimeout(() => setCountdown(countdown => countdown && countdown - 1), 1000)
  }, [countdown])

  useEffect(() => {
    setFormattedCountdown(DateUtils.formatDurationInSeconds(countdown))
  }, [countdown])

  const start = useCallback((duration: number) => {
    setCountdown(duration)
  }, [])

  const stop = useCallback(() => {
    setCountdown(undefined)
  }, [])

  return { countdown, formattedCountdown, start, stop }
}

export default useCountdown
